@if (!isLoading) {
<div class="card">
  <div class="card-header">
    Payment Method
  </div>
  <div class="card-body">
    <div>
      @for (paymentMethod of paymentMethods; track paymentMethod) {
        <div>
          <i [class]="paymentMethod.IconClass"></i>{{ paymentMethod.DisplayName }}
          @if (paymentMethod.PaymentMethodType === paymentMethodTypes_AuthorizeNetPartnerCreditCard) {
            <button class="btn btn-link" (click)="editPartnerCard()">
              <i class="fa fa-edit"></i>Edit
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
}

<ng-template #authNetModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Partner Credit Card</h5>
    <button class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body-extendable">
    @if (authNetSettings) {
      <app-authnet-hosted-form [settings]="authNetSettings" (actionComplete)="reloadSettings($event)">
      </app-authnet-hosted-form>
    }
  </div>
</ng-template>